import React, { FC, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { LinearProgress, LoadingDescription } from "../styled";

import { dialogResourcesSelector } from "../../../../ducks/dialogs/selectors";

export const Loading: FC<{ type: ResourceTypeLink; isLoading?: boolean; isDeleting?: boolean }> = ({
  type,
  isLoading,
  isDeleting,
}) => {
  const { t, i18n } = useTranslation("dialogs");
  const resourceNamesToDelete = useSelector(dialogResourcesSelector);
  const plural = useMemo(() => resourceNamesToDelete.length > 1, [resourceNamesToDelete]);

  const getLoadingText = useCallback((): string => {
    let text = t("deleteResources.gettingData");

    if (i18n.language === "en") {
      if (type === ResourceTypeLink.Project) text += ` ${plural ? "maps" : "map"}...`;
      if (type === ResourceTypeLink.Layer) text += ` ${plural ? "layers" : "layer"}...`;
      if (type === ResourceTypeLink.Table) text += ` ${plural ? "tables" : "table"}...`;
    } else {
      if (type === ResourceTypeLink.Project) text += ` ${plural ? "картах" : "карте"}...`;
      if (type === ResourceTypeLink.Layer) text += ` ${plural ? "слоях" : "слое"}...`;
      if (type === ResourceTypeLink.Table) text += `б ${plural ? "источниках данных" : "источнике данных"}...`;
    }

    return text;
  }, [plural, type, t, i18n]);

  const getDeletingText = useCallback((): string => {
    let text = t("deleteResources.deletion");

    if (i18n.language === "en") {
      if (type === ResourceTypeLink.Project) text += ` ${plural ? "maps" : "map"}...`;
      if (type === ResourceTypeLink.Layer) text += ` ${plural ? "layers" : "layer"}...`;
      if (type === ResourceTypeLink.Table) text += ` ${plural ? "tables" : "table"}...`;
    } else {
      if (type === ResourceTypeLink.Project) text += ` ${plural ? "карт" : "карты"}...`;
      if (type === ResourceTypeLink.Layer) text += ` ${plural ? "слоев" : "слоя"}...`;
      if (type === ResourceTypeLink.Table) text += ` ${plural ? "источников данных" : "источника данных"}...`;
    }

    return text;
  }, [plural, type, t, i18n]);

  return (
    <>
      <LoadingDescription>{isLoading ? getLoadingText() : isDeleting ? getDeletingText() : null}</LoadingDescription>
      <LinearProgress />
    </>
  );
};
